import React, {
    PureComponent
} from 'react';
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom';
import { Row, Col, Panel, PanelGroup, Button, Nav, InputGroup, Input, ControlLabel, ButtonGroup, ButtonToolbar, InputPicker } from 'rsuite';
import ReactExport from "react-export-excel";
import * as moment from 'moment'
import RTableGeneral from '../../../componentsGeneral/Rsuite/Table/RTableGeneral';
import RButtonHideShowFilter from '../../../componentsGeneral/Rsuite/Button/RButtonHideShowFilter';
import { palletCaseSkuStatusWithDeleted } from '../../../../app/appConfig';
import RSearchInputNumberAsString from '../../../componentsGeneral/Rsuite/SearchInput/RSearchInputNumberAsString';
import RSelectPicker from '../../../componentsGeneral/Rsuite/InputPicker/RSelectPicker';
import RDatePickerRange from '../../../componentsGeneral/Rsuite/DatePicker/RDatePickerRange';
import queryString from 'query-string';
import { queryStringParse, replaceNegativeWithZero, isNumeric, formatStringForAPI, uniqueArray, convertNanToZero, formatTrueFalseToBit, formatNumberForAPI } from '../../../../resources/logic/functions';
import PalletBuildLoadDrawer from './PalletBuildLoadDrawer';
import RSelectPickerCreatable from '../../../componentsGeneral/Rsuite/InputPicker/RSelectPickerCreatable';
import InventoryPalletWarehouseDataElements from '../../../dataComponentsInventory/InventoryPalletWarehouseDataElements';
import InventoryCaseWarehouseDataElements from '../../../dataComponentsInventory/InventoryCaseWarehouseDataElements';
import InventorySkuWarehouseDataElements from '../../../dataComponentsInventory/InventorySkuWarehouseDataElements';
import RCheckPicker from '../../../componentsGeneral/Rsuite/InputPicker/RCheckPicker';
import { textNumbersSymbolsInputmask } from '../../../../resources/logic/inputMasks';
import BuildPalletDrawer from './BuildPalletDrawer';
import NewPalletBarcodeModal from './NewPalletBarcodeModal';
import PrintBarcodesModal from './PrintBarcodesModal';
import AddToExistingLoadDrawer from './AddToExistingLoadDrawer';
import HistoryTypeModal from '../_GeneralLotComponents/HistoryTypeModal';
import MovePalletModal from '../PalletDetail/MovePalletModal';
import MoveMultipleCaseDrawer from './MoveMultipleCaseDrawer';

// const tableIdCol = "SkuID"

const footerStyles = {
    padding: '10px 2px',
    borderTop: '1px solid #e5e5e5'
};


//For excel export
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var currentDateTime = moment().format("_YYYY-MM-DDTHH-mm-ss")

const CustomNav = ({ active, onSelect, ...props }) => {
    return (
        <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>

            <Nav.Item eventKey="pallet">Pallet</Nav.Item>
            <Nav.Item eventKey="case">Case</Nav.Item>
            <Nav.Item eventKey="sku">Unit</Nav.Item>
        </Nav>
    );
};

const styles = {
    marginBottom: 15
};

const mountRef = React.createRef();

class InventoryPalletCaseSku extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            //Nav
            reportNav: 'pallet',

            // Table Check Box
            checkedKeys: [],

            //Search Values
            isFilterShown: true,
            searchContainer: '',
            searchSKU: '',

            searchWarehouseLocation: null,
            searchPalletBarcode: '',
            searchCaseSku: '',
            searchCaseBarcode: '',
            searchCaseSerial: '',
            searchCaseLotCode: '',
            searchUnitSku: '',
            searchUnitSerial: '',
            searchUnitLotCode: '',

            searchStatus: [1, 2],


            searchCustomerRef: null,
            searchRecoveryDateStart: null,
            searchRecoveryDateEnd: null,


            // searchCarrier: null,
            // searchMinETADischargeStart: null,
            // searchMinETADischargeEnd: null,


            // serachAssignedDriver: '',
            // searchMawbColorCode: null,

            //Add to existing Load
            ExistingLoadID: null,
            existingLoadData: {},
            showAddToExistingLoadDrawer: false,
            AddToExistingLoadDict: {},
            unsavedExistingLoadChanges: false,



            //Build Load Drawer
            BuildLoadDict: {},
            LocationDict: {},
            NewLoadData: {},
            unsavedBuildLoadChanges: false,
            showBuildLoadDrawer: false,
            existingDataChangeLoading: false,


            //Build Pallet Drawer 
            showBuildPalletDrawer: false,
            BuildNewPalletDict: {},
            NewPalletOversize: null,
            NewPalletLocation: null,
            NewPalletUnsavedChanges: false,

            //Print Barcodes
            newBarcodeModalShown: false,

            //Print Barcodes
            printBarcodeModalShown: false,
            barcodePrintList: null,
            PalletBarcodeData: null,
            CaseBarcodeData: null,


            //History Type Modal
            historyTypeModalOpen: false,
            historyTypeID: null,



            //Move Pallet
            movePalletModalShown: false,
            movePalletWarehouseLocationID: null,

            //Move Multiple Case
            isMoveMultipleCaseDrawerOpen: false,


        };
        //Nav
        this.handleReportNavSelect = this.handleReportNavSelect.bind(this);
        this.onClickReportNav = this.onClickReportNav.bind(this);


        // Table Check Box
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handleCheck = this.handleCheck.bind(this);

        // Table Sort
        this.handleSortColumn = this.handleSortColumn.bind(this);

        //Filter hide Show
        this.onClickIsFilterShown = this.onClickIsFilterShown.bind(this);
        this.onClickResetFilters = this.onClickResetFilters.bind(this);

        //Search Values
        this.onChangeState = this.onChangeState.bind(this);
        this.onChangeSearchContainer = this.onChangeSearchContainer.bind(this);
        this.onChangeSearchSKU = this.onChangeSearchSKU.bind(this);
        this.onChangeSearchStatus = this.onChangeSearchStatus.bind(this);
        this.onChangeSearchCustomerRef = this.onChangeSearchCustomerRef.bind(this)
        this.onChangeSearchRecoveryDateStart = this.onChangeSearchRecoveryDateStart.bind(this);
        this.onChangeSearchRecoveryDateEnd = this.onChangeSearchRecoveryDateEnd.bind(this);



        //Table buttons
        this.onClickDetails = this.onClickDetails.bind(this);


        //Build Load Drawer
        this.onChangeBuildLoadDrawer = this.onChangeBuildLoadDrawer.bind(this);
        this.onChangeLoad = this.onChangeLoad.bind(this);
        this.onChangeLocation = this.onChangeLocation.bind(this);
        this.onClickBuildLoad = this.onClickBuildLoad.bind(this);
        this.closeBuildLoadDrawer = this.closeBuildLoadDrawer.bind(this);
        this.onClickBuildLoadDrawerSave = this.onClickBuildLoadDrawerSave.bind(this);
        this.onClickRemoveFromBuild = this.onClickRemoveFromBuild.bind(this);



        this.onClickRemoveFromAdd = this.onClickRemoveFromAdd.bind(this);

        //Inventory Delete
        this.onClickInventoryDelete = this.onClickInventoryDelete.bind(this);

        //Add to existing Load
        this.onClickAddToExistingLoad = this.onClickAddToExistingLoad.bind(this);
        this.onChangeExistingLoadDrawer = this.onChangeExistingLoadDrawer.bind(this);
        this.onClickExistingLoadDrawerSave = this.onClickExistingLoadDrawerSave.bind(this);
        this.closeExistingLoadDrawer = this.closeExistingLoadDrawer.bind(this);
        this.onClickRemoveFromExistingBuild = this.onClickRemoveFromExistingBuild.bind(this);
        this.onClickSelectExistingLoad = this.onClickSelectExistingLoad.bind(this);

        //Build Pallet Drawer
        this.onChangePalletDrawer = this.onChangePalletDrawer.bind(this);
        this.removeCasePalletDrawer = this.removeCasePalletDrawer.bind(this);
        this.openPalletDrawer = this.openPalletDrawer.bind(this);
        this.onClickPrintBarcode = this.onClickPrintBarcode.bind(this);
        this.closePalletDrawer = this.closePalletDrawer.bind(this);
        this.savePalletDrawer = this.savePalletDrawer.bind(this);


        //Print Barcodes
        this.openPrintNewPalletBarcodes = this.openPrintNewPalletBarcodes.bind(this);
        this.closePrintNewPalletBarcodes = this.closePrintNewPalletBarcodes.bind(this);


        //Print Barcodes
        this.openPrintBarcodes = this.openPrintBarcodes.bind(this);
        this.closePrintBarcodes = this.closePrintBarcodes.bind(this);




        //Move Pallet
        this.movePalletModalShown = this.movePalletModalShown.bind(this);
        this.handleSavePalletModal = this.handleSavePalletModal.bind(this);
        this.handleClosePalletModal = this.handleClosePalletModal.bind(this);
        this.onChangePalletModal = this.onChangePalletModal.bind(this);


        //Move Case

        this.toggleMoveMultipleCaseDrawer = this.toggleMoveMultipleCaseDrawer.bind(this);

        this.onClickSelectPalletMoveMultipleCase = this.onClickSelectPalletMoveMultipleCase.bind(this);


    }




    componentDidMount() {
        this.loadSortFromStorage()
        this.updateParamsFromURL()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.warehouseSelection !== this.props.warehouseSelection) {
            this.setState({
                checkedKeys: []
            });
        }
        if (prevProps.customerSelection !== this.props.customerSelection) {
            this.setState({
                checkedKeys: []
            });
        }


        if (prevProps.InventoryPalletCreateNewPostSuccessful !== this.props.InventoryPalletCreateNewPostSuccessful && this.props.InventoryPalletCreateNewPostSuccessful) {
            this.setState({
                showBuildPalletDrawer: false,
                // BuildNewPalletDict: {},
                NewPalletOversize: null,
                NewPalletLocation: null,
                NewPalletUnsavedChanges: false,
            });

            if (this.props.InventoryNewPalletBarcode !== null) {
                this.openPrintNewPalletBarcodes()
            }
        }


    }

    updateParamsFromURL = () => {
        const values = queryString.parse(this.props.location.search)

        try {
            var paramReportNav = queryStringParse(values.reportnav)
        }
        catch (e) {
            var paramReportNav = null
        }
        if (paramReportNav != null) {
            this.handleReportNavSelect(paramReportNav)
        }


        try {
            var paramContainer = queryStringParse(values.container)
        }
        catch (e) {
            var paramContainer = null
        }
        if (paramContainer != null) {
            this.onChangeSearchContainer(paramContainer)
        }
        try {
            var paramSKU = queryStringParse(values.sku)
        }
        catch (e) {
            var paramSKU = null
        }
        if (paramSKU != null) {
            this.onChangeSearchSKU(paramSKU)
        }

        try {
            var paramStatus = values.statusid.split(',').map(Number);
        }
        catch (e) {
            var paramStatus = null
        }
        if (paramStatus != null) {
            this.onChangeSearchStatus(paramStatus)
        }


        try {
            var paramCustomerRefID = queryStringParse(values.customerrefid)
        }
        catch (e) {
            var paramCustomerRefID = null
        }
        if (paramCustomerRefID != null) {
            this.onChangeSearchCustomerRef(paramCustomerRefID)
        }

        try {
            var date = queryStringParse(values.recoverydtstart)
            if (date === null) {
                var paramRecoveryDateStart = null
            }
            else {
                var dateValue = new Date(date);
                var dayAdd = moment(dateValue).add(1, 'days')
                var paramRecoveryDateStart = dayAdd
            }
        }
        catch (e) {
            var paramRecoveryDateStart = null
        }
        if (paramRecoveryDateStart != null) {
            this.onChangeSearchRecoveryDateStart(paramRecoveryDateStart)
        }

        try {
            var date = queryStringParse(values.recoverydtend)
            if (date === null) {
                var paramRecoveryDateEnd = null
            }
            else {
                var dateValue = new Date(date);
                var dayAdd = moment(dateValue).add(1, 'days')
                var paramRecoveryDateEnd = dayAdd
            }
        }
        catch (e) {
            var paramRecoveryDateEnd = null
        }
        this.onChangeSearchRecoveryDateEnd(paramRecoveryDateEnd)


        try {
            var paramWarehouselocationid = queryStringParse(values.warehouselocationid)
            this.onChangeState(paramWarehouselocationid, 'searchWarehouseLocation')
        }
        catch (e) { }

        try {
            var paramPalletbarcode = queryStringParse(values.palletbarcode)
            this.onChangeState(paramPalletbarcode, 'searchPalletBarcode')
        }
        catch (e) { }

        try {
            var paramCasesku = queryStringParse(values.casesku)
            this.onChangeState(paramCasesku, 'searchCaseSku')
        }
        catch (e) { }
        try {
            var paramcasebarcode = queryStringParse(values.casebarcode)
            this.onChangeState(paramcasebarcode, 'searchCaseBarcode')
        }
        catch (e) { }
        try {
            var paramcaseserial = queryStringParse(values.caseserial)
            this.onChangeState(paramcaseserial, 'searchCaseSerial')
        }
        catch (e) { }
        try {
            var paramcaselotcode = queryStringParse(values.caselotcode)
            this.onChangeState(paramcaselotcode, 'searchCaseLotCode')
        }
        catch (e) { }
        try {
            var paramunitsku = queryStringParse(values.unitsku)
            this.onChangeState(paramunitsku, 'searchUnitSku')
        }
        catch (e) { }
        try {
            var paramunitserial = queryStringParse(values.unitserial)
            this.onChangeState(paramunitserial, 'searchUnitSerial')
        }
        catch (e) { }
        try {
            var paramunitlotcode = queryStringParse(values.unitlotcode)
            this.onChangeState(paramunitlotcode, 'searchUnitLotCode')
        }
        catch (e) { }


        try {
            var paramfiltershown = queryStringParse(values.filtershown)
            this.onClickIsFilterShown(null, paramfiltershown)

        }
        catch (e) { }


    }


    //Change State
    onChangeState(e, statename) {
        this.setState({
            [statename]: e
        });
    }

    //Nav
    handleReportNavSelect(activeKey) {
        this.setState({
            reportNav: activeKey,
            checkedKeys: []
        });
    }

    onClickReportNav(activeKey) {
        this.handleReportNavSelect(activeKey)

        if (activeKey != this.state.reportnav) {

            var sDT = null
            var eDT = null

            if (this.state.searchRecoveryDateStart === null) {
                sDT = null
            }
            else {
                sDT = "'" + moment(this.state.searchRecoveryDateStart).format('YYYY-MM-DD') + "'"
            }
            if (this.state.searchRecoveryDateEnd === null) {
                eDT = null
            }
            else {
                eDT = "'" + moment(this.state.searchRecoveryDateEnd).format('YYYY-MM-DD') + "'"
            }

            if (this.props.warehouseSelection == null) {
                // window.alert('Please select a warehouse and customer.')
            }
            else if (this.props.customerSelection == null) {
                // window.alert('Please select a customer.')
            }
            else {
                try {

                    var searchStatus = this.state.searchStatus
                    var searchContainer = this.state.searchContainer
                    var searchSKU = this.state.searchSKU

                    var searchWarehouseLocation = this.state.searchWarehouseLocation

                    var searchPalletBarcode = this.state.searchPalletBarcode
                    var searchCaseSku = this.state.searchCaseSku
                    var searchCaseBarcode = this.state.searchCaseBarcode
                    var searchCaseSerial = this.state.searchCaseSerial
                    var searchCaseLotCode = this.state.searchCaseLotCode
                    var searchUnitSku = this.state.searchUnitSku
                    var searchUnitSerial = this.state.searchUnitSerial
                    var searchUnitLotCode = this.state.searchUnitLotCode

                    this.props.history.push({
                        search:
                            'reportnav=' + activeKey + '&' +
                            'container=' + searchContainer + '&' +
                            'sku=' + searchSKU + '&' +
                            'statusid=' + searchStatus + '&' +
                            'recoverydtstart=' + sDT + '&' +
                            'recoverydtend=' + eDT + '&' +

                            'warehouselocationid=' + searchWarehouseLocation + '&' +

                            'palletbarcode=' + searchPalletBarcode + '&' +
                            'casesku=' + searchCaseSku + '&' +
                            'casebarcode=' + searchCaseBarcode + '&' +
                            'caseserial=' + searchCaseSerial + '&' +
                            'caselotcode=' + searchCaseLotCode + '&' +
                            'unitsku=' + searchUnitSku + '&' +
                            'unitserial=' + searchUnitSerial + '&' +
                            'unitlotcode=' + searchUnitLotCode

                    });
                }
                catch (e) { }
            }
        }
        else {

        }
    }



    //Table on click details
    onClickDetails(e, rowData, history) {
        var rowID
        var path
        var pathid

        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
            path = 'palletdetails'
            pathid = 'palletid'

            try {
                var paramID = rowData[rowID]
                history.push({
                    pathname: path,
                    search: pathid + '=\'' + paramID + '\''
                });
            }
            catch (e) {
            }

        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
            path = 'casedetails'
            pathid = 'caseid'

            try {
                var paramID = rowData[rowID]
                history.push({
                    pathname: path,
                    search: pathid + '=\'' + paramID + '\''
                });
            }
            catch (e) {
            }
        }
        else if (this.state.reportNav === 'sku') {

            path = 'unitdetails'
            try {
                var paramSkuID = rowData['SkuID']
                var paramPalletID = rowData['PalletID']
                var paramCaseID = rowData['CaseID']

                var paramUnitID = rowData['CaseSkuID']

                history.push({
                    pathname: path,
                    search: 'skuid=' + paramSkuID + '&' +
                        'palletid=' + paramPalletID + '&' +
                        'unitid=' + paramUnitID + '&' +
                        'caseid=' + paramCaseID

                });
            }
            catch (e) {
            }


        }


    }



    // Table Sort
    saveSortTosessionStorage(sortColumn, sortType) {
        try {
            sessionStorage.setItem('sortcolumn', sortColumn)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortType', sortType)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortURLPathname', this.props.location.pathname)
        }
        catch (e) { }
    }
    loadSortFromStorage() {
        var sortColumn = null
        var sortType = null
        var pathName = null
        try {
            sortColumn = sessionStorage.getItem('sortcolumn')
        }
        catch (e) { }
        try {
            sortType = sessionStorage.getItem('sortType')
        }
        catch (e) { }
        try {
            pathName = sessionStorage.getItem('sortURLPathname')
        }
        catch (e) { }
        if (pathName === this.props.location.pathname) {

            this.handleSortColumn(sortColumn, sortType)
        }
    }
    handleSortColumn(sortColumn, sortType) {
        this.setState({
            loading: true
        });
        this.saveSortTosessionStorage(sortColumn, sortType)
        setTimeout(() => {
            this.setState({
                sortColumn,
                sortType,
                loading: false
            });
        }, 100);
    }




    // Table Check Box
    handleCheckAll(value, checked, data) {
        var rowID
        var statusID

        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
            statusID = 'PalletStatusID'
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
            statusID = 'CaseStatusID'
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
            statusID = 'CaseStatusID'
        }

        const checkedKeys = checked
            ? []
            : data.filter(item => item[statusID] == '1' || item[statusID] == '2').map(item => item[rowID]);
        this.setState({
            checkedKeys
        });
    }

    // // Table Check Box
    // handleCheckAll(value, checked, data) {
    //     var rowID

    //     if (this.state.reportNav === 'pallet') {
    //         rowID = 'PalletID'
    //     }
    //     else if (this.state.reportNav === 'case') {
    //         rowID = 'CaseID'
    //     }
    //     else if (this.state.reportNav === 'sku') {
    //         rowID = 'CaseSkuID'
    //     }

    //     const checkedKeys = checked ? [] : data.map(item => item[rowID]);
    //     this.setState({
    //         checkedKeys
    //     });
    // }
    handleCheck(value, checked) {
        var rowID
        var currentCheckedRow

        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
            currentCheckedRow = this.props.InventoryPalletWarehouseData.filter(x => value === x[rowID])
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
            currentCheckedRow = this.props.InventoryCaseWarehouseData.filter(x => value === x[rowID])
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
            currentCheckedRow = this.props.InventorySkuWarehouseData.filter(x => value === x[rowID])
        }

        var currentStatusID
        if (this.state.reportNav === 'pallet') {
            currentStatusID = currentCheckedRow[0]['PalletStatusID']
        }
        else if (this.state.reportNav === 'case') {
            currentStatusID = currentCheckedRow[0]['CaseStatusID']
        }
        else if (this.state.reportNav === 'sku') {
            currentStatusID = currentCheckedRow[0]['CaseStatusID']
        }

        if (currentStatusID == '1' || currentStatusID == '2') {
            const { checkedKeys } = this.state;
            const nextCheckedKeys = checked
                ? [...checkedKeys, value]
                : checkedKeys.filter(item => item !== value);
            this.setState({
                checkedKeys: nextCheckedKeys
            });
        }
        else {
            // window.alert('Nothing remaining to load.')
        }

    }


    //Filter
    onClickIsFilterShown(e, isFilterShown) {
        if (isFilterShown) {
            this.setState({
                isFilterShown: false
            });
        }
        else {
            this.setState({
                isFilterShown: true
            });
        }
    }
    onClickResetFilters(e) {
        this.setState({
            isFilterShown: false
        });
        this.setState({
            searchContainer: '',
            searchSKU: '',
            searchWarehouseLocation: null,
            searchPalletBarcode: '',
            searchCaseSku: '',
            searchCaseBarcode: '',
            searchCaseSerial: '',
            searchCaseLotCode: '',
            searchUnitSku: '',
            searchUnitSerial: '',
            searchUnitLotCode: '',

            searchStatus: [1, 2],
            searchCustomerRef: null,
            searchCarrier: null,
            searchMinETADischargeStart: null,
            searchMinETADischargeEnd: null,
            searchRecoveryDateStart: null,
            searchRecoveryDateEnd: null,
            serachAssignedDriver: '',
            searchMawbColorCode: null

        });
        // this.props.history.push({
        //     search: ''
        // });

        var reportNav = this.state.reportNav
        var searchStatus = [1, 2]


        this.props.history.push({
            search:
                'statusid=' + searchStatus + '&' +
                'reportnav=' + reportNav
        });

        setTimeout(() => {
            this.setState({
                isFilterShown: true
            });
        }, 500);
    }

    onClickApplySearch(e) {
        // this.setState({
        //     searchContainer: '',
        //     searchSKU: '',
        // });

        var sDT = null
        var eDT = null


        if (this.state.searchRecoveryDateStart === null) {
            sDT = null
        }
        else {
            sDT = "'" + moment(this.state.searchRecoveryDateStart).format('YYYY-MM-DD') + "'"
        }
        if (this.state.searchRecoveryDateEnd === null) {
            eDT = null
        }
        else {
            eDT = "'" + moment(this.state.searchRecoveryDateEnd).format('YYYY-MM-DD') + "'"
        }

        if (this.props.warehouseSelection == null) {
            window.alert('Please select a warehouse and customer.')
        }
        else if (this.props.customerSelection == null) {
            window.alert('Please select a customer.')
        }
        else {
            try {
                var reportNav = this.state.reportNav

                var searchStatus = this.state.searchStatus
                var searchCustomerRef = this.state.searchCustomerRef
                // var searchCarrier = this.state.searchCarrier
                // var serachAssignedDriver = this.state.serachAssignedDriver
                // var searchMawbColorCode = this.state.searchMawbColorCode

                var searchWarehouseLocation = this.state.searchWarehouseLocation
                var searchContainer = this.state.searchContainer
                var searchPalletBarcode = this.state.searchPalletBarcode
                var searchCaseSku = this.state.searchCaseSku
                var searchCaseBarcode = this.state.searchCaseBarcode
                var searchCaseSerial = this.state.searchCaseSerial
                var searchCaseLotCode = this.state.searchCaseLotCode
                var searchUnitSku = this.state.searchUnitSku
                var searchUnitSerial = this.state.searchUnitSerial
                var searchUnitLotCode = this.state.searchUnitLotCode

                // container

                this.props.history.push({
                    search:
                        'reportnav=' + reportNav + '&' +
                        'warehouselocationid=' + searchWarehouseLocation + '&' +
                        'statusid=' + searchStatus + '&' +
                        'customerrefid=' + searchCustomerRef + '&' +
                        // 'carrier=' + searchCarrier + '&' +
                        // 'assigneddriver=' + serachAssignedDriver + '&' +
                        // 'mawbcolorcode=' + searchMawbColorCode + '&' +
                        'recoverydtstart=' + sDT + '&' +
                        'recoverydtend=' + eDT + '&' +
                        'container=' + searchContainer + '&' +
                        'palletbarcode=' + searchPalletBarcode + '&' +
                        'casesku=' + searchCaseSku + '&' +
                        'casebarcode=' + searchCaseBarcode + '&' +
                        'caseserial=' + searchCaseSerial + '&' +
                        'caselotcode=' + searchCaseLotCode + '&' +
                        'unitsku=' + searchUnitSku + '&' +
                        'unitserial=' + searchUnitSerial + '&' +
                        'unitlotcode=' + searchUnitLotCode

                });
            }
            catch (e) { }
        }
    }


    onSearchClearOtherFilters() {
        this.setState({
            searchStatus: null,
            searchCustomerRef: null,
            searchCarrier: null,
            searchMinETADischargeStart: null,
            searchMinETADischargeEnd: null,
            searchRecoveryDateStart: null,
            searchRecoveryDateEnd: null,
            serachAssignedDriver: '',
            searchMawbColorCode: null
        });

    }






    onChangeSearchContainer(e) {
        this.onSearchClearOtherFilters()
        this.setState({
            searchContainer: e,
            searchSKU: '',
        });
    }

    onChangeSearchSKU(e) {
        this.onSearchClearOtherFilters()
        this.setState({
            searchSKU: e,
            searchContainer: '',
        });
    }

    onChangeSearchStatus(e) {
        this.setState({
            searchStatus: e
        });
    }

    onChangeSearchCustomerRef(e) {
        this.setState({
            searchCustomerRef: e
        });
    }


    onChangeSearchCarrier(e) {
        this.setState({
            searchCarrier: e
        });
    }

    onChangeSearchMinETADischargeStart(e) {
        this.setState({
            searchMinETADischargeStart: e
        });
    }
    onChangeSearchMinETADischargeEnd(e) {
        this.setState({
            searchMinETADischargeEnd: e
        });
    }

    onChangeSearchRecoveryDateStart(e) {
        this.setState({
            searchRecoveryDateStart: e
        });
    }
    onChangeSearchRecoveryDateEnd(e) {
        this.setState({
            searchRecoveryDateEnd: e
        });
    }
    onChangeSearchAssigedDriver(e) {
        this.setState({
            serachAssignedDriver: e
        });
    }
    onChangeSearchMawbColorCode(e) {
        this.setState({
            searchMawbColorCode: e
        });
    }


    // //Table buttons
    // onClickDetails(e, rowData, history) {
    //     try {
    //         var paramID = rowData[tableIdCol]
    //         history.push({
    //             pathname: 'skudetails',
    //             search: 'skuid=\'' + paramID + '\''
    //         });
    //     }
    //     catch (e) {
    //     }
    // }

    // //Inventory Delete
    // onClickInventoryDelete(e) {
    //     if (this.state.checkedKeys.length > 0) {




    //         if (window.confirm('Are you sure you want to adjust the selected rows?')) {

    //             var rowID
    //             if (this.state.reportNav === 'pallet') {
    //                 rowID = 'PalletID'
    //             }
    //             else if (this.state.reportNav === 'case') {
    //                 rowID = 'CaseID'
    //             }
    //             else if (this.state.reportNav === 'sku') {
    //                 rowID = 'CaseSkuID'
    //             }

    //             var buildDeleteArray = {}
    //             if (this.state.reportNav === 'pallet') {
    //                 buildDeleteArray = this.props.InventoryPalletWarehouseData.filter(x => this.state.checkedKeys.includes(x.PalletID))

    //                 // this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, _HistoryTypeID, _ContainerIdList, buildDeleteArray, _PalletBarcode, _CaseIdList, _CaseBarcode, _UnitIdList, _UnitsToRemove)
    //             }
    //             else if (this.state.reportNav === 'case') {
    //                 buildDeleteArray = this.props.InventoryCaseWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseID))
    //                 // this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, _HistoryTypeID, _ContainerIdList, buildDeleteArray, _PalletBarcode, _CaseIdList, _CaseBarcode, _UnitIdList, _UnitsToRemove)
    //             }
    //             else if (this.state.reportNav === 'sku') {
    //                 buildDeleteArray = this.props.InventorySkuWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseSkuID))
    //                 // this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, _HistoryTypeID, _ContainerIdList, buildDeleteArray, _PalletBarcode, _CaseIdList, _CaseBarcode, _UnitIdList, _UnitsToRemove)
    //             }
    //         }
    //     }
    //     else {
    //         window.alert('Please select rows.')
    //     }
    // }

    //History Type Modal
    handleModalOpen = () => {

        this.setState({ historyTypeModalOpen: true });

    };

    handleModalClose = () => {
        this.setState({ historyTypeModalOpen: false });
    };

    handleModalSelect = (value) => {
        if (window.confirm('Are you sure you want to remove the selected rows?  This will also remove contents from inventory.')) {
            var checkedIds = this.state.checkedKeys.join(",");
            if (this.state.reportNav === 'pallet') {
                this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, value, null, formatStringForAPI(checkedIds), null, null, null, null, null)
            }
            else if (this.state.reportNav === 'case') {
                this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, value, null, null, null, formatStringForAPI(checkedIds), null, null, null)
            }
            else if (this.state.reportNav === 'sku') {
                this.props.inventoryLotDeleteContainerPalletCaseUnitPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, value, null, null, null, null, null, formatStringForAPI(checkedIds), null)
            }
        }

    };

    onClickInventoryDelete = (e) => {
        if (this.state.checkedKeys.length > 0) {
            this.handleModalOpen();
        }
        else {
            window.alert('Please select rows.')
        }
    };

    //Add to existing Load
    onClickAddToExistingLoad(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {
            if (this.state.checkedKeys.length > 0) {
                var buildLoadArray = {};
                var rowID;
                if (this.state.reportNav === 'pallet') {
                    rowID = 'PalletID'
                    buildLoadArray = this.props.InventoryPalletWarehouseData.filter(x => this.state.checkedKeys.includes(x.PalletID))
                }
                else if (this.state.reportNav === 'case') {
                    rowID = 'CaseID'
                    buildLoadArray = this.props.InventoryCaseWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseID))
                }
                else if (this.state.reportNav === 'sku') {
                    rowID = 'CaseSkuID'
                    buildLoadArray = this.props.InventorySkuWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseSkuID))
                }

                this.props.inventoryLoadLotGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, null, '1', null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null)

                this.setState({
                    ExistingLoadID: null,
                    existingLoadData: {},
                    showAddToExistingLoadDrawer: true,
                    AddToExistingLoadDict: buildLoadArray,
                });
            }
            else {
                window.alert('Please select rows.')
            }
        }
        else {
            window.alert('Please select one warehouse and one customer to add to a load.')
        }
    }


    onClickSelectExistingLoad(e, rowData, history) {
        const loadID = rowData['LoadID'];
        this.setState({
            unsavedExistingLoadChanges: true,
            ExistingLoadID: loadID,
            existingLoadData: rowData
        });

    }


    onChangeExistingLoadDrawer = (e, item, label) => {

        var rowID
        var currentItem

        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
        }

        currentItem = item[rowID]

        var currentBuildDict = this.state.AddToExistingLoadDict
        var buildKeyToUpdate = currentBuildDict.findIndex(item => item[rowID] === currentItem)

        currentBuildDict[buildKeyToUpdate][label] = e

        this.setState({
            unsavedExistingLoadChanges: true,
            NewLoadData: currentBuildDict
        });

        this.forceUpdate()



    };


    // onChangeExistingLoad = (e, label) => {
    //     var loadDict = this.state.NewLoadData
    //     loadDict[label] = e
    //     this.setState({
    //         unsavedExistingLoadChanges: true,
    //         NewLoadData: loadDict
    //     });

    //     this.forceUpdate()
    // }

    // onChangeExistingLocation = (e, item, locationitem, label, skuWarehouseLocationID) => {
    //     setTimeout(() => {
    //         this.setState({
    //             existingDataChangeLoading: true
    //         });
    //     }, 50);

    //     var skuId = item.SkuID;
    //     var itemIndex = this.state.LocationDict[skuId].findIndex(({ SkuWarehouseLocationID }) => SkuWarehouseLocationID === skuWarehouseLocationID);
    //     var newLocationBuildDict = this.state.LocationDict

    //     newLocationBuildDict[skuId][itemIndex][label] = isNumeric(e)

    //     var currentAddToExistingLoadDictIndex = this.state.AddToExistingLoadDict.findIndex(({ SkuID }) => SkuID === skuId);
    //     var currentAddToExistingLoadDict = this.state.AddToExistingLoadDict

    //     try {
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewUnitsLoaded'] = replaceNegativeWithZero((newLocationBuildDict[currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Units, 0)))
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewCasesLoaded'] = replaceNegativeWithZero((newLocationBuildDict[currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Cases, 0)))
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewPallets'] = replaceNegativeWithZero((newLocationBuildDict[currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Pallets, 0)))
    //     }
    //     catch (e) {
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewUnitsLoaded'] = replaceNegativeWithZero(currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['UnitsReceived'] - currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['UnitsLoaded'])
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewCasesLoaded'] = replaceNegativeWithZero(currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['CasesReceived'] - currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['CasesLoaded'])
    //         currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['NewPallets'] = replaceNegativeWithZero(currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['PalletsReceived'] - currentAddToExistingLoadDict[currentAddToExistingLoadDictIndex]['PalletsLoaded'])
    //     }

    //     this.setState({
    //         unsavedExistingLoadChanges: true,
    //         AddToExistingLoadDict: currentAddToExistingLoadDict,
    //         LocationDict: newLocationBuildDict,
    //         existingDataChangeLoading: false
    //     });
    // }

    // onClickRemoveFromExisting = (e, item, locationitem, skuWarehouseLocationID) => {

    //     this.onChangeLocation(0, item, locationitem, 'Units', skuWarehouseLocationID)
    //     this.onChangeLocation(0, item, locationitem, 'Cases', skuWarehouseLocationID)
    //     this.onChangeLocation(0, item, locationitem, 'Pallets', skuWarehouseLocationID)

    //     this.forceUpdate()
    // }

    onClickRemoveFromExistingBuild(e, item) {

        var rowID;
        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
        }

        var prevBuild = {}
        prevBuild = this.state.AddToExistingLoadDict

        var idToRemove = item[rowID];

        var itemIndex = this.state.AddToExistingLoadDict.findIndex((row) => row[rowID] === idToRemove);
        // var itemIndex = this.state.AddToExistingLoadDict.findIndex(({ rowID }) => rowID === idToRemove);
        prevBuild.splice(itemIndex, 1);

        setTimeout(() => {
            this.setState({
                AddToExistingLoadDict: prevBuild
            });
        }, 50);


        this.forceUpdate()

    }
    onClickExistingLoadDrawerSave(e) {

        if (typeof (this.state.ExistingLoadID) != null && typeof (this.state.ExistingLoadID) != '' && typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            var loadPalletDict = this.state.AddToExistingLoadDict;

            var filteredLoadPalletDict = loadPalletDict.map(item => {
                const { PalletID, CaseID, CaseSkuID, SkuID, UnitsInWhse } = item;
                let filteredItem = {};
                if (PalletID) filteredItem.PalletID = PalletID;
                if (CaseID) filteredItem.CaseID = CaseID;
                if (CaseSkuID) filteredItem.CaseSkuID = CaseSkuID;
                if (SkuID) filteredItem.SkuID = SkuID;
                if (UnitsInWhse) filteredItem.UnitsInWhse = UnitsInWhse;
                return filteredItem;
            }).filter(item => Object.keys(item).length > 0);

            var LoadPalletDictString = JSON.stringify(filteredLoadPalletDict)



            // var loadPalletDict = this.state.AddToExistingLoadDict
            // var LoadPalletDictString = JSON.stringify(loadPalletDict)

            try {
                var paramPostLoadPalletDict = "'" + LoadPalletDictString + "'"
            }
            catch (e) {
                var paramPostLoadPalletDict = null
            }

            try {
                var paramReportNav = formatStringForAPI(this.state.reportNav)
            }
            catch (e) {
                var paramReportNav = null
            }


            try {

                var paramLoadID = formatStringForAPI(this.state.ExistingLoadID)
            }
            catch (e) {
                var paramLoadID = null
            }



            this.props.inventoryLoadPalletCaseSkuPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, paramPostLoadPalletDict, paramReportNav, paramLoadID, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null)



            this.setState({
                unsavedExistingLoadChanges: false,
                showAddToExistingLoadDrawer: false
            });
            // }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }
    closeExistingLoadDrawer() {
        if (this.state.unsavedExistingLoadChanges) {
            if (window.confirm('Leave without saving changes?')) {
                this.setExistingLoadDrawerToClose()
            }
        }
        else {
            this.setExistingLoadDrawerToClose()
        }
    }

    setExistingLoadDrawerToClose() {
        this.setState({
            AddToExistingLoadDict: {},
            LocationDict: {},
            NewLoadData: {},
            unsavedExistingLoadChanges: false,
            showAddToExistingLoadDrawer: false
        });
    }





































    //Build Load Drawer
    onClickBuildLoad(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {
            if (this.state.checkedKeys.length > 0) {
                var buildLoadArray = {};
                var rowID;
                if (this.state.reportNav === 'pallet') {
                    rowID = 'PalletID'
                    buildLoadArray = this.props.InventoryPalletWarehouseData.filter(x => this.state.checkedKeys.includes(x.PalletID))
                }
                else if (this.state.reportNav === 'case') {
                    rowID = 'CaseID'
                    buildLoadArray = this.props.InventoryCaseWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseID))
                }
                else if (this.state.reportNav === 'sku') {
                    rowID = 'CaseSkuID'
                    buildLoadArray = this.props.InventorySkuWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseSkuID))
                }

                var newLoadDict = {}
                newLoadDict['PickupDate'] = null
                newLoadDict['DeliveryDate'] = null
                newLoadDict['Carrier'] = null
                newLoadDict['BOL'] = null
                newLoadDict['Trailer'] = null
                newLoadDict['Seal'] = null

                this.setState({
                    BuildLoadDict: buildLoadArray,
                    NewLoadData: newLoadDict,
                    showBuildLoadDrawer: true,
                });
            }
            else {
                window.alert('Please select rows.')
            }
        }
        else {
            window.alert('Please select one warehouse and one customer to build a load.')
        }
    }


    onChangeBuildLoadDrawer = (e, item, label) => {

        var rowID
        var currentCheckedRow
        var currentItem

        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
        }


        currentItem = item[rowID]

        var currentBuildDict = this.state.BuildLoadDict
        var buildKeyToUpdate = currentBuildDict.findIndex(item => item[rowID] === currentItem)


        // currentCheckedRow = this.state.BuildLoadDict.filter(x => currentItem === x[rowID])

        currentBuildDict[buildKeyToUpdate][label] = e
        // this.handleSetStatePallet(currentPalletDict)

        this.setState({
            unsavedBuildLoadChanges: true,
            NewLoadData: currentBuildDict
        });

        this.forceUpdate()

        // var currentLoadData = this.state.NewLoadData
        // currentLoadData[label] = event
        // this.setState({
        //     unsavedBuildLoadChanges: true,
        //     NewLoadData: currentLoadData
        // });

    };



    onChangeLoad = (e, label) => {
        var loadDict = this.state.NewLoadData
        loadDict[label] = e
        this.setState({
            unsavedBuildLoadChanges: true,
            NewLoadData: loadDict
        });

        this.forceUpdate()



        // setTimeout(() => {
        //     this.setState({
        //         existingDataChangeLoading: true
        //     });
        // }, 50);


        // var skuId = item.SkuID;
        // var itemIndex = this.state.BuildLoadDict.findIndex(({ SkuID }) => SkuID === skuId);
        // var currentBuildLoadDict = this.state.BuildLoadDict

        // currentBuildLoadDict[itemIndex][label] = isNumeric(event)

        // this.setState({
        //     unsavedBuildLoadChanges: true,
        //     BuildLoadDict: currentBuildLoadDict,

        //     existingDataChangeLoading: false
        // });
    };
    onChangeLocation = (e, item, locationitem, label, skuWarehouseLocationID) => {
        setTimeout(() => {
            this.setState({
                existingDataChangeLoading: true
            });
        }, 50);

        var skuId = item.SkuID;
        var itemIndex = this.state.LocationDict[skuId].findIndex(({ SkuWarehouseLocationID }) => SkuWarehouseLocationID === skuWarehouseLocationID);
        var newLocationBuildDict = this.state.LocationDict

        newLocationBuildDict[skuId][itemIndex][label] = isNumeric(e)

        var currentBuildLoadDictIndex = this.state.BuildLoadDict.findIndex(({ SkuID }) => SkuID === skuId);
        var currentBuildLoadDict = this.state.BuildLoadDict

        try {
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewUnitsLoaded'] = replaceNegativeWithZero((newLocationBuildDict[currentBuildLoadDict[currentBuildLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Units, 0)))
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewCasesLoaded'] = replaceNegativeWithZero((newLocationBuildDict[currentBuildLoadDict[currentBuildLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Cases, 0)))
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewPallets'] = replaceNegativeWithZero((newLocationBuildDict[currentBuildLoadDict[currentBuildLoadDictIndex]['SkuID']].reduce((a, v) => a = a + v.Pallets, 0)))
        }
        catch (e) {
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewUnitsLoaded'] = replaceNegativeWithZero(currentBuildLoadDict[currentBuildLoadDictIndex]['UnitsReceived'] - currentBuildLoadDict[currentBuildLoadDictIndex]['UnitsLoaded'])
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewCasesLoaded'] = replaceNegativeWithZero(currentBuildLoadDict[currentBuildLoadDictIndex]['CasesReceived'] - currentBuildLoadDict[currentBuildLoadDictIndex]['CasesLoaded'])
            currentBuildLoadDict[currentBuildLoadDictIndex]['NewPallets'] = replaceNegativeWithZero(currentBuildLoadDict[currentBuildLoadDictIndex]['PalletsReceived'] - currentBuildLoadDict[currentBuildLoadDictIndex]['PalletsLoaded'])
        }

        this.setState({
            unsavedBuildLoadChanges: true,
            BuildLoadDict: currentBuildLoadDict,
            LocationDict: newLocationBuildDict,
            existingDataChangeLoading: false
        });
    }

    onClickRemoveFromAdd = (e, item, locationitem, skuWarehouseLocationID) => {

        this.onChangeLocation(0, item, locationitem, 'Units', skuWarehouseLocationID)
        this.onChangeLocation(0, item, locationitem, 'Cases', skuWarehouseLocationID)
        this.onChangeLocation(0, item, locationitem, 'Pallets', skuWarehouseLocationID)

        this.forceUpdate()
    }

    onClickRemoveFromBuild(e, item) {

        var rowID;
        if (this.state.reportNav === 'pallet') {
            rowID = 'PalletID'
        }
        else if (this.state.reportNav === 'case') {
            rowID = 'CaseID'
        }
        else if (this.state.reportNav === 'sku') {
            rowID = 'CaseSkuID'
        }

        var prevBuild = {}
        prevBuild = this.state.BuildLoadDict

        var idToRemove = item[rowID];

        var itemIndex = this.state.BuildLoadDict.findIndex((row) => row[rowID] === idToRemove);
        // var itemIndex = this.state.BuildLoadDict.findIndex(({ rowID }) => rowID === idToRemove);
        prevBuild.splice(itemIndex, 1);

        setTimeout(() => {
            this.setState({
                BuildLoadDict: prevBuild
            });
        }, 50);




        this.forceUpdate()

    }
    onClickBuildLoadDrawerSave(e, totalUnitsNumber, totalRecoveredNum, totalPalleteNum) {

        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            var loadPalletDict = this.state.BuildLoadDict;

            var filteredLoadPalletDict = loadPalletDict.map(item => {
                const { PalletID, CaseID, CaseSkuID, SkuID, UnitsInWhse } = item;
                let filteredItem = {};
                if (PalletID) filteredItem.PalletID = PalletID;
                if (CaseID) filteredItem.CaseID = CaseID;
                if (CaseSkuID) filteredItem.CaseSkuID = CaseSkuID;
                if (SkuID) filteredItem.SkuID = SkuID;
                if (UnitsInWhse) filteredItem.UnitsInWhse = UnitsInWhse;
                return filteredItem;
            }).filter(item => Object.keys(item).length > 0);

            var LoadPalletDictString = JSON.stringify(filteredLoadPalletDict)




            // var loadPalletDict = this.state.BuildLoadDict
            // var LoadPalletDictString = JSON.stringify(loadPalletDict)

            try {
                var paramPostLoadPalletDict = "'" + LoadPalletDictString + "'"
            }
            catch (e) {
                var paramPostLoadPalletDict = null
            }


            try {
                if (this.state.NewLoadData.PickupDate != null) {
                    var paramPostPickupDate = "'" + moment(this.state.NewLoadData.PickupDate).format('YYYY-MM-DD') + "'"
                }
                else {
                    var paramPostPickupDate = null
                }
            }
            catch (e) {
                var paramPostPickupDate = null
            }
            try {
                if (this.state.NewLoadData.DeliveryDate != null) {
                    var paramPostDeliveryDate = "'" + moment(this.state.NewLoadData.DeliveryDate).format('YYYY-MM-DD') + "'"
                }
                else {
                    var paramPostDeliveryDate = null
                }
            }
            catch (e) {
                var paramPostDeliveryDate = null
            }
            try {
                // var paramPostCarrier = "'" + this.state.NewLoadData.Carrier + "'"
                var paramPostCarrier = formatStringForAPI(this.state.NewLoadData.Carrier)
            }
            catch (e) {
                var paramPostCarrier = null
            }
            try {
                // var paramPostBOL = "'" + this.state.NewLoadData.BOL + "'"
                var paramPostBOL = formatStringForAPI(this.state.NewLoadData.BOL)
            }
            catch (e) {
                var paramPostBOL = null
            }
            try {
                // var paramPostTrailer = "'" + this.state.NewLoadData.Trailer + "'"
                var paramPostTrailer = formatStringForAPI(this.state.NewLoadData.Trailer)
            }
            catch (e) {
                var paramPostTrailer = null
            }
            try {
                // var paramPostSeal = "'" + this.state.NewLoadData.Seal + "'"
                var paramPostSeal = formatStringForAPI(this.state.NewLoadData.Seal)
            }
            catch (e) {
                var paramPostSeal = null
            }


            // try {
            //     var paramPostTotalUnits = totalUnitsNumber
            // }
            // catch (e) {
            //     var paramPostTotalUnits = null
            // }

            // try {
            //     var paramPostTotalCases = totalRecoveredNum
            // }
            // catch (e) {
            //     var paramPostTotalCases = null
            // }
            // try {
            //     var paramPostTotalPallets = totalPalleteNum
            // }
            // catch (e) {
            //     var paramPostTotalPallets = null
            // }
            try {
                var paramPostDesintation = formatStringForAPI(this.state.NewLoadData.Destination)
            }
            catch (e) {
                var paramPostDesintation = null
            }
            try {
                var paramPostLoadStatusID = 1
            }
            catch (e) {
                var paramPostLoadStatusID = 1
            }
            // try {
            //     var paramPostLoadInventoryLotSkuData = "'" + poString + "'"
            // }
            // catch (e) {
            //     var paramPostLoadInventoryLotSkuData = null
            // }
            // try {
            //     var paramPostLocationInventoryLotSkuData = "'" + locationString + "'"
            // }
            // catch (e) {
            //     var paramPostLocationInventoryLotSkuData = null
            // }
            try {
                var paramReportNav = formatStringForAPI(this.state.reportNav)
            }
            catch (e) {
                var paramReportNav = null
            }




            try {
                var paramPostMC = formatStringForAPI(this.state.NewLoadData.MC)
            }
            catch (e) {
                var paramPostMC = null
            }
            try {
                var paramPostDOT = formatStringForAPI(this.state.NewLoadData.DOT)
            }
            catch (e) {
                var paramPostDOT = null
            }
            try {
                var paramPostDriver = formatStringForAPI(this.state.NewLoadData.Driver)
            }
            catch (e) {
                var paramPostDriver = null
            }
            try {
                var paramPostTruck = formatStringForAPI(this.state.NewLoadData.Truck)
            }
            catch (e) {
                var paramPostTruck = null
            }
            try {
                var paramPostTruckPlate = formatStringForAPI(this.state.NewLoadData.TruckPlate)
            }
            catch (e) {
                var paramPostTruckPlate = null
            }
            try {
                var paramPostTrailerPlate = formatStringForAPI(this.state.NewLoadData.TrailerPlate)
            }
            catch (e) {
                var paramPostTrailerPlate = null
            }
            try {
                var paramPostNotes = formatStringForAPI(this.state.NewLoadData.Notes)
            }
            catch (e) {
                var paramPostNotes = null
            }



            this.props.inventoryLoadPalletCaseSkuPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, paramPostLoadPalletDict, paramReportNav, null, paramPostPickupDate, paramPostDeliveryDate, paramPostCarrier, paramPostBOL, paramPostTrailer, paramPostSeal, null, null, null, paramPostDesintation, null, paramPostLoadStatusID, null, paramPostMC, paramPostDOT, paramPostDriver, paramPostTruck, paramPostTruckPlate, paramPostTrailerPlate, paramPostNotes)




            // if (this.state.NewLoadData.Carrier == null || this.state.NewLoadData.Carrier == '') {
            //     window.alert('Please enter Carrier')
            // }
            // else if (this.state.NewLoadData.Trailer == null || this.state.NewLoadData.Trailer == '') {
            //     window.alert('Please enter Trailer')
            // }

            // if (window.confirm('Save Data?')) {

            // const currentListPo = this.state.BuildLoadDict
            // const newPoToPost = currentListPo.map(({ SkuID, NewUnitsLoaded, NewCasesLoaded, NewPallets }) => ({ SkuID, NewUnitsLoaded, NewCasesLoaded, NewPallets }));
            // var poString = JSON.stringify(newPoToPost)

            // const currentListLocation = this.state.LocationDict
            // var newLocationToPost = []
            // for (let x in currentListLocation) {
            //     for (let i in currentListLocation[x]) {
            //         try {

            //             if ((currentListLocation[x][i]['Units'] === null || currentListLocation[x][i]['Units'] == 0) && (currentListLocation[x][i]['Cases'] === null || currentListLocation[x][i]['Cases'] == 0) && (currentListLocation[x][i]['Pallets'] === null || currentListLocation[x][i]['Pallets'] == 0)) {

            //             }
            //             else {
            //                 newLocationToPost.push({ 'SkuID': x, 'WarehouseLocationID': currentListLocation[x][i]['WarehouseLocationID'], 'SkuWarehouseLocationID': currentListLocation[x][i]['SkuWarehouseLocationID'], 'Units': currentListLocation[x][i]['Units'], 'Cases': currentListLocation[x][i]['Cases'], 'Pallets': currentListLocation[x][i]['Pallets'], 'Oversize': formatTrueFalseToBit(currentListLocation[x][i]['Oversize']) })
            //             }
            //         }
            //         catch (e) { }
            //     }
            // }
            // var locationString = JSON.stringify(newLocationToPost)




            this.setState({
                unsavedBuildLoadChanges: false,
                showBuildLoadDrawer: false
            });
            // }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }
    closeBuildLoadDrawer() {
        if (this.state.unsavedBuildLoadChanges) {
            if (window.confirm('Leave without saving changes?')) {
                this.setBuildLoadDrawerToClose()
            }
        }
        else {
            this.setBuildLoadDrawerToClose()
        }
    }

    setBuildLoadDrawerToClose() {
        this.setState({
            BuildLoadDict: {},
            LocationDict: {},
            NewLoadData: {},
            unsavedBuildLoadChanges: false,
            showBuildLoadDrawer: false
        });
    }



    //Build Pallet Drawer
    openPalletDrawer() {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {
            if (this.state.checkedKeys.length > 0) {
                var buildPalletArray = {};
                var rowID;

                rowID = 'CaseID'
                buildPalletArray = this.props.InventoryCaseWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseID))

                this.setState({
                    showBuildPalletDrawer: true,
                    BuildNewPalletDict: buildPalletArray,
                    NewPalletOversize: null,
                    NewPalletLocation: null,
                    NewPalletUnsavedChanges: false,
                });
            }
            else {
                window.alert('Please select rows.')
            }
        }
        else {
            window.alert('Please select one warehouse and one customer to build a load.')
        }
    }

    closePalletDrawer() {
        this.setState({
            showBuildPalletDrawer: false
        });
    }

    onChangePalletDrawer(e, label) {
        this.setState({
            NewPalletUnsavedChanges: true,
            [label]: e
        });
    }

    removeCasePalletDrawer(e, item) {

        var rowID;
        rowID = 'CaseID'

        var prevBuild = {}
        prevBuild = this.state.BuildNewPalletDict

        var idToRemove = item[rowID];

        var itemIndex = this.state.BuildNewPalletDict.findIndex((row) => row[rowID] === idToRemove);
        // var itemIndex = this.state.BuildNewPalletDict.findIndex(({ rowID }) => rowID === idToRemove);
        prevBuild.splice(itemIndex, 1);

        setTimeout(() => {
            this.setState({
                BuildNewPalletDict: prevBuild
            });
        }, 50);


        this.forceUpdate()

    }



    savePalletDrawer() {

        if (
            typeof (this.props.warehouseSelection) === 'number' &&
            typeof (this.props.customerSelection) === 'number'
        ) {
            // Your code here

            if (this.state.NewPalletLocation == null) {
                window.alert('Please select new warehouse location.')
            }
            else {


                // const caseIdList = this.state.BuildNewPalletDict.map(item => item.CaseID).join(',');

                const casePalletList = this.state.BuildNewPalletDict.map(item => ({
                    CaseID: item.CaseID,
                    PalletID: item.PalletID
                }));

                var casePalletDictString = JSON.stringify(casePalletList)

                // var loadPalletDict = this.state.BuildNewPalletDict
                // var LoadPalletDictString = JSON.stringify(loadPalletDict)

                try {
                    var paramPostLoadPalletDict = "'" + casePalletDictString + "'"
                }
                catch (e) {
                    var paramPostLoadPalletDict = null
                }


                try {
                    var paramNewPalletOversize = formatTrueFalseToBit(this.state.NewPalletOversize)
                }
                catch (e) {
                    var paramNewPalletOversize = null
                }
                try {
                    var paramNewPalletLocation = formatNumberForAPI(this.state.NewPalletLocation)
                }
                catch (e) {
                    var paramNewPalletLocation = null
                }

                this.props.inventoryPalletCreateNewPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, paramPostLoadPalletDict, paramNewPalletLocation, paramNewPalletOversize, null)


            }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }



    //Print new barcode
    openPrintNewPalletBarcodes() {
        this.setState({
            newBarcodeModalShown: true
        })
    }

    closePrintNewPalletBarcodes() {
        this.setState({
            newBarcodeModalShown: false,
            BuildNewPalletDict: {},
        })
    }



    //Print  barcode

    onClickPrintBarcode(e, type) {
        if (this.state.checkedKeys.length > 0) {

            var printBarcodeArray = {};
            var barcodeType;
            let PalletBarcodeData
            let CaseBarcodeData

            if (type == 'pallet') {
                barcodeType = 'PalletBarcode'
                printBarcodeArray = this.props.InventoryPalletWarehouseData.filter(x => this.state.checkedKeys.includes(x.PalletID))
                PalletBarcodeData = printBarcodeArray
                CaseBarcodeData = null
            }
            else if (type == 'case') {
                barcodeType = 'CaseBarcode'
                printBarcodeArray = this.props.InventoryCaseWarehouseData.filter(x => this.state.checkedKeys.includes(x.CaseID))
                CaseBarcodeData = printBarcodeArray
                PalletBarcodeData = null
            }

            let BarcodeList = printBarcodeArray.map(item => item[barcodeType]);
            let uniqueBarcodeList = [...new Set(BarcodeList)];
            let uniqueBarcodeString = uniqueBarcodeList.join(', ');


            // let uniqueBarcodeString = '01-1-A-1,25-9-A-1,EVO L 25-8-B-1,EVO L 01-1-B-2,L 01-1-B-2'

            this.setState({
                barcodePrintList: uniqueBarcodeString,
                PalletBarcodeData: PalletBarcodeData,
                CaseBarcodeData: CaseBarcodeData,
            });

            this.openPrintBarcodes()
        }
        else {
            window.alert('Please select rows.')
        }
    }


    openPrintBarcodes() {
        this.setState({
            printBarcodeModalShown: true
        })
    }

    closePrintBarcodes() {
        this.setState({
            printBarcodeModalShown: false,
            barcodePrintList: null,
            PalletBarcodeData: null,
            CaseBarcodeData: null,
        })
    }





    //Move Pallet
    movePalletModalShown() {
        this.props.userWarehouseLocationsGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].WarehouseID), formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].CustomerID));

        // This function could be used to control the visibility of the modal
        this.setState({ movePalletModalShown: true, movePalletWarehouseLocationID: null });
    }

    handleSavePalletModal() {

        if (typeof (this.props.warehouseSelection) === 'number' ) {
            if (this.state.movePalletWarehouseLocationID == null) {
                window.alert('Please select new location.')
            }
            else if (formatNumberForAPI(this.state.movePalletWarehouseLocationID) === formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].WarehouseLocationID)) {
                window.alert('Pallet is already in this location.')
            }
            else {

                const checkedKeysString = this.state.checkedKeys.join(','); // Joins the array elements with a comma

                // This function could be used to handle the saving of data when the modal's save button is clicked
                // You would typically make an API call here to save your data
                this.props.inventoryPalletWarehouseLocationPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].WarehouseID), null, null, null, formatNumberForAPI(this.state.movePalletWarehouseLocationID), null, null, null, null, null, formatStringForAPI(checkedKeysString))

                // After saving the data, you can close the modal
                this.setState({ movePalletModalShown: false, checkedKeys: [] });
            }
        }
        else { window.alert('Please select only one Warehouse to move Pallets.') }

    }

    handleClosePalletModal() {
        // This function could be used to handle the closing of the modal
        this.setState({ movePalletModalShown: false });
    }

    onChangePalletModal(e) {
        // This function could be used to handle changes in the form inputs in the modal
        // 'e' is the event object, you can get the value of the input like this: e.target.value
        // You would typically set the state here with the new value
        this.setState({ movePalletWarehouseLocationID: e });
    }



    //Move Multiple Case
    toggleMoveMultipleCaseDrawer() {
        this.setState(prevState => ({
            isMoveMultipleCaseDrawerOpen: !prevState.isMoveMultipleCaseDrawerOpen,
        }));
    }

    onClickMoveMultipleCase(e, rowData, history) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            const warehouseId = this.props.warehouseSelection
            const customerID = this.props.customerSelection

            this.props.inventoryPalletWarehouseLocationGet2(this.props.currentUserEmail, this.props.userSignInData.AuthToken, null, warehouseId, customerID, "'1,2'", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null)

            this.toggleMoveMultipleCaseDrawer();
        }

        else { window.alert('Please select only one Warehouse and one Customer to move Cases.') }
    };


    onClickSelectPalletMoveMultipleCase(e, rowData, history) {
        if (window.confirm('Move selected cases to this pallet?')) {

            var newPalletID = formatNumberForAPI(rowData['PalletID'])
            // var oldPalletID = formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].PalletID)
            // var warehouseID = formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].WarehouseID)
            // var customerID = formatNumberForAPI(this.props.InventoryPalletWarehouseData[0].CustomerID)

            // const filteredTableData = this.props.InventoryCaseWarehouseData.filter(item => item.CaseStatusID == 1 || item.CaseStatusID == 2);

            // if (this.state.checkedKeys.length === filteredTableData.length) {
            //     if (window.confirm('After this case is moved, nothing will remain on pallet.  Click OK to set pallet to closed, cancel to remain open.')) {
            //         this.props.inventoryPalletWarehouseLocationPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, warehouseID, customerID, oldPalletID, null, null, 1, 5, null, null, null, null)
            //     }
            // }
            // else {
            // }

            const checkedKeysString = this.state.checkedKeys.join(','); // Joins the array elements with a comma

            this.props.inventoryCaseWarehouseLocationPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, null, null, newPalletID, null, formatStringForAPI(checkedKeysString))

            this.setState({
                isMoveCaseDrawerOpen: false,
                isMoveMultipleCaseDrawerOpen: false,
                checkedKeys: []
            });
        }

    }



    render() {
        const { checkedKeys, sortColumn, sortType } = this.state;

        if (this.props.InventoryLoadPalletCaseSkuPostLoading) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                    <p style={{ marginTop: '20px', fontSize: '20px', color: '#3396E5' }}>Please wait...</p>
                </div>
            );
        }
        

        let hideShowSearch;
        hideShowSearch = <Row style={{ marginBottom: '5px' }}>

            <Col md={24} sm={24} >

                <p>
                    {RButtonHideShowFilter(this.props.isMobile, this.state.isFilterShown, 'Filters', this.onClickIsFilterShown, this.onClickResetFilters)}
                </p>

            </Col>
        </Row>


        let warehouseLocationSearch;
        if (this.props.isWarehouseLocationsLoading) {
            warehouseLocationSearch =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.WarehouseLocationsData) !== 'undefined' && this.props.WarehouseLocationsData != null) {
            warehouseLocationSearch = <Row>
                <div style={{ marginBottom: '15px', width: '100%' }}>
                    <ControlLabel>Warehouse Location</ControlLabel>
                    <InputPicker preventOverflow
                        placeholder={'Warehouse Location...'}
                        value={this.state.searchWarehouseLocation}
                        onChange={(e) => { this.onChangeState(e, 'searchWarehouseLocation') }}
                        data={this.props.WarehouseLocationsData}
                        cleanable={true}
                        block
                    />
                </div>
            </Row>
        }
        else {
            warehouseLocationSearch = <div></div>
        }


        let searchDiv;
        if (this.state.isFilterShown) {
            // && !this.props.isTransConsigneeLoading) {
            searchDiv = <Row  >
                <Col md={24} sm={24} >

                    <Panel bordered style={{ marginBottom: '10px' }}>

                        <CustomNav appearance="tabs" active={this.state.reportNav} onSelect={this.onClickReportNav} />

                        <Col md={24} sm={24} >

                            <Row style={{ marginBottom: '10px' }}>
                                <ControlLabel>Status</ControlLabel>
                                <RCheckPicker
                                    data={palletCaseSkuStatusWithDeleted}
                                    value={this.state.searchStatus}
                                    setCheckedState={this.onChangeSearchStatus}
                                />
                            </Row>

                            {warehouseLocationSearch}

                            <Row>
                                {RDatePickerRange(
                                    this.props.isMobile,
                                    'Recovery Date',
                                    this.onChangeSearchRecoveryDateStart,
                                    this.onChangeSearchRecoveryDateEnd,
                                    this.state.searchRecoveryDateStart,
                                    this.state.searchRecoveryDateEnd
                                )}
                            </Row>



                            <Row>
                                <div >
                                    <ControlLabel>Container</ControlLabel>
                                    <InputGroup style={{ marginBottom: 10 }}>
                                        <Input value={this.state.searchContainer} onChange={(e) => { this.onChangeState(e, 'searchContainer') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                    </InputGroup>
                                </div>
                            </Row>



                            <Row>
                                <div >
                                    <ControlLabel>Pallet Barcode</ControlLabel>
                                    <InputGroup style={{ marginBottom: 10 }}>
                                        <Input value={this.state.searchPalletBarcode} onChange={(e) => { this.onChangeState(e, 'searchPalletBarcode') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                    </InputGroup>
                                </div>
                            </Row>

                            <Row >

                                <ControlLabel>Case Barcode</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchCaseBarcode} onChange={(e) => { this.onChangeState(e, 'searchCaseBarcode') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>


                        </Col>

                        <Col md={12} sm={24} style={{ marginBottom: '10px' }}>


                            <Row style={{ marginRight: 10 }}>

                                <ControlLabel>Case SKU</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchCaseSku} onChange={(e) => { this.onChangeState(e, 'searchCaseSku') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>

                            <Row style={{ marginRight: 10 }}>

                                <ControlLabel>Case Serial Number</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchCaseSerial} onChange={(e) => { this.onChangeState(e, 'searchCaseSerial') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>

                            <Row style={{ marginRight: 10 }}>

                                <ControlLabel>Case Lot Code</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchCaseLotCode} onChange={(e) => { this.onChangeState(e, 'searchCaseLotCode') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>



                        </Col>
                        <Col md={12} sm={24} style={{ marginBottom: '10px' }}>

                            <Row>

                                <ControlLabel>Unit SKU</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchUnitSku} onChange={(e) => { this.onChangeState(e, 'searchUnitSku') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>

                            <Row>

                                <ControlLabel>Unit Serial Number</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchUnitSerial} onChange={(e) => { this.onChangeState(e, 'searchUnitSerial') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>

                            <Row>

                                <ControlLabel>Unit Lot Code</ControlLabel>
                                <InputGroup style={{ marginBottom: 10 }}>
                                    <Input value={this.state.searchUnitLotCode} onChange={(e) => { this.onChangeState(e, 'searchUnitLotCode') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                </InputGroup>

                            </Row>



                        </Col>


                        <Row>

                            {/* <ButtonToolbar style={{ marginBottom: 10, textAlignLast: 'right' }}> */}
                            <Button onClick={(e) => { this.onClickApplySearch(e) }} style={{ marginRight: '10px' }}> Apply </Button>
                            <Button onClick={(e) => { this.onClickResetFilters(e) }}> Reset </Button>
                            {/* </ButtonToolbar> */}
                        </Row>

                        {/* <Row>
                            {RSelectPicker(
                                this.props.isMobile,
                                this.props.TransCustomerRefData,
                                this.state.searchCustomerRef,
                                'Customer Ref',
                                this.onChangeSearchCustomerRef,
                                this.props.history,
                                mountRef
                            )}
                        </Row> */}








                    </Panel>
                </Col>
            </Row >
        }
        else if (!this.state.isFilterShown) {
            searchDiv = <div></div>
        }






        let shipmentPalletTable;
        let tablePalletDataDiv;
        if (this.props.isInventoryPalletWarehouseLoading) {
            shipmentPalletTable = <div></div>
            tablePalletDataDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.InventoryPalletWarehouseData) !== 'undefined' && this.props.InventoryPalletWarehouseData != null) {
            const values = queryString.parse(this.props.location.search)
            try {
                var paramPoStatusID = values.statusid.split(',').map(Number);

            }
            catch (e) {
                var paramPoStatusID = []
            }

            shipmentPalletTable = RTableGeneral(
                'PalletID',     //   keyColumn,
                this.props.InventoryPalletWarehouseData,     //   tableData,
                InventoryPalletWarehouseDataElements,       //   DataElements,
                this.props.isInventoryPalletWarehouseLoading,        //   loading,

                this.props.isMobile,        //   isMobile,
                this.props.history,     //   history,

                sortColumn,     //   sortColumn,
                sortType,       //   sortType,
                this.handleSortColumn,      //   handleSortColumn,

                (paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? true : false), // checkColEntry,
                checkedKeys,       //   checkedKeys,
                this.handleCheckAll,       //   handleCheckAll,
                this.handleCheck,       //   handleCheck,

                false,      //   boolSelectButton,
                null,       //   onClickSelect,
                null,       //   selectButtonText,
                null,       //   selectHighlightRowKey,

                true,       //   link1bool,
                'Details',     //   link1text,
                this.onClickDetails,     //   link1onClick,

                false,       //   link2bool,
                null,       //   link2text,
                null  //   link2onClick
            )
            tablePalletDataDiv = <div>
                {(this.props.isMobile == true) ? <div></div> :
                    <div>
                        <Row>

                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ?
                                <div style={{ float: 'left', marginRight: '10px', marginLeft: '5px' }}>
                                    <InputGroup style={{ float: 'left', marginRight: '10px', marginBottom: '10px' }}>
                                        <InputGroup.Addon>Selected Count:</InputGroup.Addon>
                                        <Input
                                            value={this.state.checkedKeys && this.state.checkedKeys.length > 0 ? this.state.checkedKeys.length : 0}
                                            readOnly
                                            style={{ width: '60px' }}
                                        />
                                    </InputGroup>
                                </div>
                                : ''}

                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.movePalletModalShown(e) }}>Move Selected</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickBuildLoad(e) }}>Build Load Selected</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickAddToExistingLoad(e) }}>Add to Existing Load</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickInventoryDelete(e) }}>Adjust Inventory</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left' }} onClick={(e) => { this.onClickPrintBarcode(e, 'pallet') }}>Print Pallet Barcodes</Button> : ''}
                            <ExcelFile element={<Button style={{ float: 'right' }}>Export Excel</Button>} filename={'Warehouse_' + currentDateTime}>
                                <ExcelSheet data={this.props.InventoryPalletWarehouseData} name="Warehouse">
                                    {
                                        InventoryPalletWarehouseDataElements.map(
                                            ({ dBKey, displayName }, idx) => {
                                                return (
                                                    <ExcelColumn label={displayName} value={dBKey} />
                                                );
                                            }
                                        )
                                    }
                                </ExcelSheet>
                            </ExcelFile>
                        </Row>
                    </div>
                }
            </div>
        }
        else {
            shipmentPalletTable = <div></div>
            tablePalletDataDiv = <div></div>
        }




        let shipmentCaseTable;
        let tableCaseDataDiv;
        if (this.props.isInventoryCaseWarehouseLoading) {
            shipmentCaseTable = <div></div>
            tableCaseDataDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.InventoryCaseWarehouseData) !== 'undefined' && this.props.InventoryCaseWarehouseData != null) {
            const values = queryString.parse(this.props.location.search)
            try {
                var paramPoStatusID = values.statusid.split(',').map(Number);
            }
            catch (e) {
                var paramPoStatusID = []
            }
            shipmentCaseTable = RTableGeneral(
                'CaseID',     //   keyColumn,
                this.props.InventoryCaseWarehouseData,     //   tableData,
                InventoryCaseWarehouseDataElements,       //   DataElements,
                this.props.isInventoryCaseWarehouseLoading,        //   loading,

                this.props.isMobile,        //   isMobile,
                this.props.history,     //   history,

                sortColumn,     //   sortColumn,
                sortType,       //   sortType,
                this.handleSortColumn,      //   handleSortColumn,

                (paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? true : false), // checkColEntry,
                checkedKeys,       //   checkedKeys,
                this.handleCheckAll,       //   handleCheckAll,
                this.handleCheck,       //   handleCheck,

                false,      //   boolSelectButton,
                null,       //   onClickSelect,
                null,       //   selectButtonText,
                null,       //   selectHighlightRowKey,

                true,       //   link1bool,
                'Details',     //   link1text,
                this.onClickDetails,     //   link1onClick,

                false,       //   link2bool,
                null,       //   link2text,
                null  //   link2onClick
            )
            tableCaseDataDiv = <div>
                {(this.props.isMobile == true) ? <div></div> :
                    <div>
                        <Row>

                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ?
                                <div style={{ float: 'left', marginRight: '10px', marginLeft: '5px' }}>
                                    <InputGroup style={{ float: 'left', marginRight: '10px', marginBottom: '10px' }}>
                                        <InputGroup.Addon>Selected Count:</InputGroup.Addon>
                                        <Input
                                            value={this.state.checkedKeys && this.state.checkedKeys.length > 0 ? this.state.checkedKeys.length : 0}
                                            readOnly
                                            style={{ width: '60px' }}
                                        />
                                    </InputGroup>
                                </div>
                                : ''}

                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickMoveMultipleCase(e) }}>Move Selected</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickBuildLoad(e) }}>Build Load Selected</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickAddToExistingLoad(e) }}>Add to Existing Load</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.openPalletDrawer(e) }}>Build New Pallet</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickInventoryDelete(e) }}>Adjust Inventory</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left' }} onClick={(e) => { this.onClickPrintBarcode(e, 'case') }}>Print Case Barcodes</Button> : ''}

                            <ExcelFile element={<Button style={{ float: 'right' }}>Export Excel</Button>} filename={'Warehouse_' + currentDateTime}>
                                <ExcelSheet data={this.props.InventoryCaseWarehouseData} name="Warehouse">
                                    {
                                        InventoryCaseWarehouseDataElements.map(
                                            ({ dBKey, displayName }, idx) => {
                                                return (
                                                    <ExcelColumn label={displayName} value={dBKey} />
                                                );
                                            }
                                        )
                                    }
                                </ExcelSheet>
                            </ExcelFile>
                        </Row>
                    </div>
                }
            </div>
        }
        else {
            shipmentCaseTable = <div></div>
            tableCaseDataDiv = <div></div>
        }


        let shipmentSkuTable;
        let tableSkuDataDiv;
        if (this.props.isInventorySkuWarehouseLoading) {
            shipmentSkuTable = <div></div>
            tableSkuDataDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.InventorySkuWarehouseData) !== 'undefined' && this.props.InventorySkuWarehouseData != null) {
            const values = queryString.parse(this.props.location.search)
            try {
                var paramPoStatusID = values.statusid.split(',').map(Number);
            }
            catch (e) {
                var paramPoStatusID = []
            }
            shipmentSkuTable = RTableGeneral(
                'CaseSkuID',     //   keyColumn,
                this.props.InventorySkuWarehouseData,     //   tableData,
                InventorySkuWarehouseDataElements,       //   DataElements,
                this.props.isInventorySkuWarehouseLoading,        //   loading,

                this.props.isMobile,        //   isMobile,
                this.props.history,     //   history,

                sortColumn,     //   sortColumn,
                sortType,       //   sortType,
                this.handleSortColumn,      //   handleSortColumn,
                (paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? true : false), // checkColEntry,
                checkedKeys,       //   checkedKeys,
                this.handleCheckAll,       //   handleCheckAll,
                this.handleCheck,       //   handleCheck,

                false,      //   boolSelectButton,
                null,       //   onClickSelect,
                null,       //   selectButtonText,
                null,       //   selectHighlightRowKey,

                true,       //   link1bool,
                'Details',     //   link1text,
                this.onClickDetails,     //   link1onClick,

                false,       //   link2bool,
                null,       //   link2text,
                null  //   link2onClick
            )
            tableSkuDataDiv = <div>
                {(this.props.isMobile == true) ? <div></div> :
                    <div>
                        <Row>

                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ?
                                <div style={{ float: 'left', marginRight: '10px', marginLeft: '5px' }}>
                                    <InputGroup style={{ float: 'left', marginRight: '10px', marginBottom: '10px' }}>
                                        <InputGroup.Addon>Selected Count:</InputGroup.Addon>
                                        <Input
                                            value={this.state.checkedKeys && this.state.checkedKeys.length > 0 ? this.state.checkedKeys.length : 0}
                                            readOnly
                                            style={{ width: '60px' }}
                                        />
                                    </InputGroup>
                                </div>
                                : ''}


                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickBuildLoad(e) }}>Build Load Selected</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickAddToExistingLoad(e) }}>Add to Existing Load</Button> : ''}
                            {paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickInventoryDelete(e) }}>Adjust Inventory</Button> : ''}
                            <ExcelFile element={<Button style={{ float: 'right' }}>Export Excel</Button>} filename={'Warehouse_' + currentDateTime}>
                                <ExcelSheet data={this.props.InventorySkuWarehouseData} name="Warehouse">
                                    {
                                        InventorySkuWarehouseDataElements.map(
                                            ({ dBKey, displayName }, idx) => {
                                                return (
                                                    <ExcelColumn label={displayName} value={dBKey} />
                                                );
                                            }
                                        )
                                    }
                                </ExcelSheet>
                            </ExcelFile>
                        </Row>
                    </div>
                }
            </div>
        }
        else {
            shipmentSkuTable = <div></div>
            tableSkuDataDiv = <div></div>
        }




        let totalUnitsNumber;
        let totalRecoveredNumber;
        let totalPalletNumber;
        if (!this.state.existingDataChangeLoading) {
            try {
                totalUnitsNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewUnitsLoaded, 0)
            }
            catch (e) {
                totalUnitsNumber = 0
            }

            try {
                totalRecoveredNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewCasesLoaded, 0)
            }
            catch (e) {
                totalRecoveredNumber = 0
            }

            try {
                totalPalletNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewPallets, 0)
            }
            catch (e) {
                totalPalletNumber = 0
            }
        }
        else {
            try {
                totalUnitsNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewUnitsLoaded, 0)
            }
            catch (e) {
                totalUnitsNumber = 0
            }
            try {
                totalRecoveredNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewCasesLoaded, 0)
            }
            catch (e) {
                totalRecoveredNumber = 0
            }
            try {
                totalPalletNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.NewPallets, 0)
            }
            catch (e) {
                totalPalletNumber = 0
            }
        }



        let buildLoadDrawer;
        if (this.props.isInventoryLotSkuLoading) {
            totalRecoveredNumber = 0
            totalUnitsNumber = 0
            buildLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (this.props.isInventorySkuWarehouseLocationLoading) {
            totalRecoveredNumber = 0
            totalUnitsNumber = 0
            buildLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (typeof (this.state.BuildLoadDict) !== 'undefined' && this.state.BuildLoadDict != null && this.state.BuildLoadDict.length > 0 && this.state.showBuildLoadDrawer) {
            // totalRecoveredNumber = this.state.BuildLoadDict.reduce((a, v) => a = a + v.CasesReceived, 0)

            buildLoadDrawer = <PalletBuildLoadDrawer {...this.props} state={this.state} totalUnitsNumber={totalUnitsNumber} totalRecoveredNum={totalRecoveredNumber} totalPalleteNum={totalPalletNumber} onChange={this.onChangeBuildLoadDrawer} onChangeLoad={this.onChangeLoad} onChangeLocation={this.onChangeLocation} onClickRemoveFromAdd={this.onClickRemoveFromAdd} confirm={this.onClickBuildLoadDrawerSave} close={this.closeBuildLoadDrawer} remove={this.onClickRemoveFromBuild} />
        }




        let addToExistingLoadDrawer;
        if (this.props.isInventoryLoadLotLoading) {
            addToExistingLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (this.props.isInventoryLotSkuLoading) {
            addToExistingLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (this.props.isInventorySkuWarehouseLocationLoading) {
            addToExistingLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (typeof (this.props.InventoryLoadLotData) !== 'undefined' && typeof (this.state.AddToExistingLoadDict) !== 'undefined' && this.state.AddToExistingLoadDict != null && this.state.AddToExistingLoadDict.length > 0 && this.state.showAddToExistingLoadDrawer) {
            addToExistingLoadDrawer = <AddToExistingLoadDrawer {...this.props} state={this.state} onClickSelectExistingLoad={this.onClickSelectExistingLoad} onChange={this.onChangeExistingLoadDrawer} confirm={this.onClickExistingLoadDrawerSave} close={this.closeExistingLoadDrawer} remove={this.onClickRemoveFromExistingBuild} handleSortColumn={this.handleSortColumn} sortColumn={this.sortColumn} sortType={this.sortType} />
        }






        let buildPalletDrawer;
        // if (this.props.isInventoryLotSkuLoading) {
        //     totalRecoveredNumber = 0
        //     totalUnitsNumber = 0
        //     buildPalletDrawer = <div align="center">
        //         <section className="panel">
        //         </section>
        //         <Loader
        //             type="TailSpin"
        //             color="#3396E5"
        //             height="50"
        //             width="50"
        //         />
        //     </div>
        // }
        // else if (this.props.isInventorySkuWarehouseLocationLoading) {
        //     totalRecoveredNumber = 0
        //     totalUnitsNumber = 0
        //     buildPalletDrawer = <div align="center">
        //         <section className="panel">
        //         </section>
        //         <Loader
        //             type="TailSpin"
        //             color="#3396E5"
        //             height="50"
        //             width="50"
        //         />
        //     </div>
        // }
        // else 

        if (typeof (this.state.BuildNewPalletDict) !== 'undefined' && this.state.BuildNewPalletDict != null && this.state.BuildNewPalletDict.length > 0 && this.state.showBuildPalletDrawer) {
            buildPalletDrawer = <BuildPalletDrawer {...this.props} state={this.state} onChangePalletDrawer={this.onChangePalletDrawer} removeCasePalletDrawer={this.removeCasePalletDrawer} closePalletDrawer={this.closePalletDrawer} savePalletDrawer={this.savePalletDrawer} />

        }




        let tableDiv;
        if (this.state.reportNav === 'pallet') {
            tableDiv = <div>
                {tablePalletDataDiv}
                {shipmentPalletTable}
            </div>
        }
        else if (this.state.reportNav === 'case') {
            tableDiv = <div>
                {tableCaseDataDiv}
                {shipmentCaseTable}
            </div>
        }
        else if (this.state.reportNav === 'sku') {
            tableDiv = <div>
                {tableSkuDataDiv}
                {shipmentSkuTable}
            </div>
        }
        else {
            tableDiv = <div></div>
        }

        return (
            <div>
                <h3>
                    Inventory Management - Inventory
                </h3>

                {hideShowSearch}
                {searchDiv}

                <PanelGroup>

                </PanelGroup>

                {tableDiv}

                {addToExistingLoadDrawer}

                {buildLoadDrawer}

                {buildPalletDrawer}


                <NewPalletBarcodeModal {...this.props} state={this.state}
                    newBarcodeModalShown={this.state.newBarcodeModalShown}
                    closePrintNewPalletBarcodes={this.closePrintNewPalletBarcodes}
                />


                <PrintBarcodesModal {...this.props} state={this.state}
                    printBarcodeModalShown={this.state.printBarcodeModalShown}
                    closePrintBarcodes={this.closePrintBarcodes}
                    barcodePrintList={this.state.barcodePrintList}
                    PalletBarcodeData={this.state.PalletBarcodeData}
                    CaseBarcodeData={this.state.CaseBarcodeData}
                />


                <HistoryTypeModal
                    open={this.state.historyTypeModalOpen}
                    handleClose={this.handleModalClose}
                    data={this.props.InventoryLotHistoryTypeData}
                    loading={this.props.isInventoryLotHistoryTypeLoading}
                    handleSelect={this.handleModalSelect}
                />



                <MovePalletModal {...this.props} state={this.state}
                    movePalletModalShown={this.state.movePalletModalShown}
                    handleSavePalletModal={this.handleSavePalletModal}
                    handleClosePalletModal={this.handleClosePalletModal}
                    onChangePalletModal={this.onChangePalletModal}
                />



                {this.state.isMoveMultipleCaseDrawerOpen && (
                    <MoveMultipleCaseDrawer
                        {...this.props}
                        {...this.state}
                        isOpen={this.state.isMoveMultipleCaseDrawerOpen}
                        toggleDrawer={this.toggleMoveMultipleCaseDrawer}
                        sortColumn={sortColumn}
                        sortType={sortType}
                        handleSortColumn={this.handleSortColumn}
                        onClickSelectPalletMoveMultipleCase={this.onClickSelectPalletMoveMultipleCase}
                    />
                )}

            </div>
        );

    }
}

export default withRouter(InventoryPalletCaseSku);














// <Panel bordered style={{ marginBottom: '10px' }}>


// <div>
//     {/* {(this.state.reportNav === 'storage') ?
//         storageSearch :
//         inboundSearch
//     } */}
// </div>


// <Row>
//     {RSearchInputNumberAsString(
//         this.props.isMobile,
//         'Container',
//         this.onChangeSearchContainer,
//         this.props.history,
//         'container',
//         this.state.searchContainer
//     )}
// </Row>


// <Row>
//     {RSearchInputNumberAsString(
//         this.props.isMobile,
//         'Pallet Barcode',
//         this.onChangeSearchContainer,
//         this.props.history,
//         'palletbarcode',
//         this.state.searchContainer
//     )}
// </Row>

// <Row>
//     {RSearchInputNumberAsString(
//         this.props.isMobile,
//         'Case Barcode',
//         this.onChangeSearchContainer,
//         this.props.history,
//         'casebarcode',
//         this.state.searchContainer
//     )}
// </Row>

// <Row>
//     {RSearchInputNumberAsString(
//         this.props.isMobile,
//         'SKU',
//         this.onChangeSearchSKU,
//         this.props.history,
//         'sku',
//         this.state.searchSKU
//     )}
// </Row>
// </Panel>